var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.9987 6.16658C5.72257 6.16658 5.4987 6.39046 5.4987 6.66658C5.4987 6.94271 5.72257 7.16658 5.9987 7.16658C6.27482 7.16658 6.4987 6.94271 6.4987 6.66658C6.4987 6.39046 6.27482 6.16658 5.9987 6.16658ZM12.6654 1.33325H3.33203C2.22795 1.33447 1.33325 2.22917 1.33203 3.33325V9.99992C1.33325 11.104 2.22795 11.9987 3.33203 11.9999H11.5274L14.0964 14.5689C14.1589 14.6315 14.2436 14.6666 14.332 14.6666C14.5161 14.6666 14.6654 14.5173 14.6654 14.3333V3.33325C14.6641 2.22917 13.7694 1.33447 12.6654 1.33325ZM13.9987 13.5286L11.901 11.4309C11.8385 11.3684 11.7538 11.3333 11.6654 11.3333H3.33203C2.59603 11.3323 1.99963 10.7359 1.9987 9.99992V3.33325C1.99963 2.59725 2.59603 2.00085 3.33203 1.99992H12.6654C13.4014 2.00085 13.9978 2.59725 13.9987 3.33325V13.5286ZM7.9987 6.16658C7.72257 6.16658 7.4987 6.39046 7.4987 6.66658C7.4987 6.94271 7.72257 7.16658 7.9987 7.16658C8.27482 7.16658 8.4987 6.94271 8.4987 6.66658C8.4987 6.39046 8.27482 6.16658 7.9987 6.16658ZM9.9987 6.16658C9.72257 6.16658 9.4987 6.39046 9.4987 6.66658C9.4987 6.94271 9.72257 7.16658 9.9987 7.16658C10.2748 7.16658 10.4987 6.94271 10.4987 6.66658C10.4987 6.39046 10.2748 6.16658 9.9987 6.16658Z",
    fill: "#398D94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.5d9c5b0a.svg";
export { ForwardRef as ReactComponent };